(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
        this.onScroll();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rgr_slider"] && !Shopify.designMode) return;
  try {
    
  jQuery(document).ready(function () {
            let slideCount = $('.rgr_slide').length;

            $('.rgr_slide').each(function () {
                $(this).css('--slide-count', slideCount);
            });

            // for (let i = 1; i <= slideCount; i++) {
            //     $('#rgr_slide-numbers').append('<li data-class="' + i + '">' + i + '</li>');
            // }

            $('#rgr_slide-numbers li:first-child').addClass('active');

            function detectActive() {
                let activeSlide = $("#rgr_slider-wrapper .rgr_slide").first().attr("data-class");
                $("#rgr_slide-numbers li").removeClass("active");
                $("#rgr_slide-numbers li[data-class=" + activeSlide + "]").addClass("active");
            }

            $("#rgr_slide-numbers").on("click", "li", function () {
                let targetSlide = $(this).attr('data-class');
                navigateToSlide(targetSlide);
            });

            $('.rgr_content  .next-btn').on('click', function () {
                let slides = $('#rgr_slider-wrapper .rgr_slide');
                let nextSlide = $(this).data('next-slide');
                if (nextSlide) {
                    navigateToSlide(nextSlide + 1);
                }
            });

            function navigateToSlide(targetSlide) {
                let $targetSlide = $("#rgr_slider-wrapper .rgr_slide[data-class=" + targetSlide + "]");
                $targetSlide.hide().prependTo("#rgr_slider-wrapper").fadeIn();

                adjustPositions();
                detectActive();
            }

            function adjustPositions() {
                $('#rgr_slider-wrapper .rgr_slide').each(function (index, slide) {
                    $(slide).attr('data-position', index + 1);

                    let XVal = 0;
                    const breakpoints = [
                        { width: 1600, value: 90 },
                        { width: 1400, value: 80 },
                        { width: 1200, value: 75 },
                        { width: 990, value: 60 }
                    ];

                    $.each(breakpoints, function (index, breakpoint) {
                        if ($(window).width() > breakpoint.width) {
                            XVal = breakpoint.value;
                            return false;
                        }
                    });


                    let scaleValue = 1 - (index * 0.1);
                    let translateXValue = index === 0 ? 0 : (index * (XVal));

                    $(slide).css({
                        'z-index': slideCount - index,
                        'transform': 'translateX(' + translateXValue + 'px) scale(' + scaleValue + ')',
                    });
                });
            }

            adjustPositions();
            detectActive();
        });

  } catch(e) { console.error(e); }
})();
})();
